import {
  Box,
  Button,
  CircularProgress,
  Container,
  Step,
  StepLabel,
  Stepper,
  useMediaQuery,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { API } from "../../../scripts/api";
import axiosInstance from "../../../scripts/axiosInspector";
import HeaderReq from "../../../scripts/functions/headerReq";
import Cities from "./cities";
import Info from "./info";
import States from "./state";

const Register = () => {
  const { themeDisplay } = useSelector((state) => state.ThemeToggler);
  const [currentStep, setCurrentStep] = useState(1);
  const [finalSelect, setFinalSelect] = useState({});
  const [selected, setSelected] = useState({});
  const [data, setData] = useState({});
  const [allProvince, setAllProvince] = useState([]);
  const [cities, setCities] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [err, setErr] = useState(false);
  const [loadingCities, setLoadingCities] = useState(false);
  const navigate = useNavigate();
  const [error, setError] = useState({});
  const isMd = useMediaQuery("(min-width:756px)");

  useEffect(() => {
    setLoading(true);
    axiosInstance
      .get(
        API.public.province +
          `?guidCountryRecNo=9d4ec04c-0b6a-40e6-b1b2-179b711b859e`,
        HeaderReq()
      )
      .then((res) => {
        setAllProvince(res?.data?.data);
        setLoading(false);
      })
      .catch((err) => {
        toast.error("خطایی پیش آمده است مجدد تلاش کنید");
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    if (finalSelect?.selectedArea) {
      setLoadingCities(true);
      var CS = allProvince?.find(
        (item) => item?.chEnName === finalSelect?.selectedArea
      );
      setData({
        ...data,
        ostan: CS,
        city: {},
      });
      axiosInstance
        .get(
          API.public.cities + `?guidOstanRecNo=${CS?.guidRecNo}`,
          HeaderReq()
        )
        .then((res) => {
          setCities(res?.data?.data);
          setLoadingCities(false);
        })
        .catch((err) => {
          toast.error("خطایی پیش آمده است مجدد تلاش کنید");
          setLoadingCities(false);
        });
      setCurrentStep(2);
    }
  }, [finalSelect]);
  const handleSumbit = () => {
    if (
      !data?.chNationalCode ||
      !data?.chMobile ||
      !data?.tintSexType ||
      !data?.chFirstName ||
      !data?.chLastName ||
      !data?.chJobTitle ||
      !data?.chAddress
    ) {
      setError({
        chNationalCode: !data?.chNationalCode,
        chMobile: !data?.chMobile,
        tintSexType: !data?.tintSexType,
        chFirstName: !data?.chFirstName,
        chLastName: !data?.chLastName,
        chJobTitle: !data?.chJobTitle,
        chAddress: !data?.chAddress,
      });
      toast.error("لطفا تمامی موارد را کامل نمایید");
    } else {
      setLoadingSubmit(true);
      axiosInstance
        .post(
          API.user.register,
          {
            chNationalCode: data?.chNationalCode,
            chMobile: data?.chMobile,
            tintSexType: data?.tintSexType,
            chFirstName: data?.chFirstName,
            chLastName: data?.chLastName,
            chJobTitle: data?.chJobTitle,
            chAddress: data?.chAddress,
            guidOstanRecNo: data?.ostan?.guidRecNo,
            guidCityRecNo: data?.city?.guidRecNo,
          },
          HeaderReq()
        )
        .then((res) => {
          if (res?.data?.isSuccess) {
            toast.success(res?.data?.message);
            navigate("/");
          } else {
            toast.error(res?.data?.message);
          }
          setLoadingSubmit(false);
        })
        .catch((err) => {
          toast.error("خطایی رخ داده است مجدد تلاش کنید");
          setLoadingSubmit(false);
        });
    }
  };
  return (
    <div
      style={{ backdropFilter: "opacity(0.5)" }}
      className="relative mainBg min-h-[100vh]"
    >
      {currentStep === 3 ? (
        <>
          {isMd ? (
            <>
              {themeDisplay === "blue" ? (
                <img
                  className="md:max-h-[100vh] md:w-[100vw] md:object-cover  absolute left-0 top-[-2px]"
                  src="/assets/images/login/2-13.svg"
                  alt=""
                />
              ) : themeDisplay === "green" ? (
                <img
                  className="md:max-h-[100vh] md:w-[100vw] md:object-cover  absolute left-0 top-[-2px]"
                  src="/assets/images/login/3-13.svg"
                  alt=""
                />
              ) : themeDisplay === "orange" ? (
                <img
                  className="md:max-h-[100vh] md:w-[100vw] md:object-cover  absolute left-0 top-[-2px]"
                  src="/assets/images/login/4-13.svg"
                  alt=""
                />
              ) : themeDisplay === "dark" ? (
                <img
                  className="md:max-h-[100vh] md:w-[100vw] md:object-cover  absolute left-0 top-[-2px]"
                  src="/assets/images/login/5-13.svg"
                  alt=""
                />
              ) : (
                <img
                  className="md:max-h-[100vh] md:w-[100vw] md:object-cover  absolute left-0 top-[-2px]"
                  src="/assets/images/login/1-13.svg"
                  alt=""
                />
              )}
            </>
          ) : (
            <>
              {themeDisplay === "blue" ? (
                <img
                  className="md:max-h-[100vh] md:w-[100vw] md:object-cover  absolute left-0 top-[-2px]"
                  src="/assets/images/login/2-11.svg"
                  alt=""
                />
              ) : themeDisplay === "green" ? (
                <img
                  className="md:max-h-[100vh] md:w-[100vw] md:object-cover  absolute left-0 top-[-2px]"
                  src="/assets/images/login/3-11.svg"
                  alt=""
                />
              ) : themeDisplay === "orange" ? (
                <img
                  className="md:max-h-[100vh] md:w-[100vw] md:object-cover  absolute left-0 top-[-2px]"
                  src="/assets/images/login/4-11.svg"
                  alt=""
                />
              ) : themeDisplay === "dark" ? (
                <img
                  className="md:max-h-[100vh] md:w-[100vw] md:object-cover  absolute left-0 top-[-2px]"
                  src="/assets/images/login/5-11.svg"
                  alt=""
                />
              ) : (
                <img
                  className="md:max-h-[100vh] md:w-[100vw] md:object-cover  absolute left-0 top-[-2px]"
                  src="/assets/images/login/1-11.svg"
                  alt=""
                />
              )}
            </>
          )}
        </>
      ) : (
        <>
          {themeDisplay === "blue" ? (
            <img
              className="md:max-h-[100vh] md:w-[100vw] md:object-cover  absolute left-0 top-[-2px]"
              src="/assets/images/login/2-01.svg"
              alt=""
            />
          ) : themeDisplay === "green" ? (
            <img
              className="md:max-h-[100vh] md:w-[100vw] md:object-cover  absolute left-0 top-[-2px]"
              src="/assets/images/login/3-01.svg"
              alt=""
            />
          ) : themeDisplay === "orange" ? (
            <img
              className="md:max-h-[100vh] md:w-[100vw] md:object-cover  absolute left-0 top-[-2px]"
              src="/assets/images/login/4-01.svg"
              alt=""
            />
          ) : themeDisplay === "dark" ? (
            <img
              className="md:max-h-[100vh] md:w-[100vw] md:object-cover  absolute left-0 top-[-2px]"
              src="/assets/images/login/5-01.svg"
              alt=""
            />
          ) : (
            <img
              className="md:max-h-[100vh] md:w-[100vw] md:object-cover  absolute left-0 top-[-2px]"
              src="/assets/images/login/1-01.svg"
              alt=""
            />
          )}
        </>
      )}

      <div className="flex w-full relative z-50 justify-center items-center text-white h-[4rem] ext-lg ">
        ثبت نام
      </div>
      <Box className="mt-1 md:mx-10 mx-1 py-6 light rounded-md ">
        <Stepper
          activeStep={currentStep - 1}
          alternativeLabel
          sx={{
            direction: "ltr",

            width: "100%",
            backgroundColor: (theme) => "transparent !important",
            ".MuiStepLabel-label": {
              color: "#fff !important",
            },
          }}
        >
          {[
            `استان : ${data?.ostan?.chName || ""} `,
            `شهر : ${data?.city?.chName || ""}`,
            `ثبت نام`,
          ]?.map((label) => (
            <Step key={label}>
              <StepLabel
                sx={{
                  ".MuiStepLabel-label": {
                    fontSize: {
                      md: "0.9rem !important",
                      xs: "1rem !important",
                    },
                  },
                }}
              >
                {label}
              </StepLabel>
            </Step>
          ))}
        </Stepper>
        <Container className="md:z-50 md:relative" maxWidth="xl">
          {currentStep === 1 ? (
            <States
              selected={selected}
              setSelected={setSelected}
              finalSelect={finalSelect}
              allProvince={allProvince}
              loading={loading}
              setFinalSelect={setFinalSelect}
            />
          ) : currentStep === 2 ? (
            <>
              <div className="flex w-full loginButton my-7 items-center justify-between">
                <Button
                  sx={{ width: "165px" }}
                  onClick={() => navigate("/")}
                  variant="contained"
                >
                  بازگشت به صفحه ورود
                </Button>{" "}
                <Button
                  sx={{ width: "165px", color: "#fff", borderColor: "#fff" }}
                  onClick={() => setCurrentStep(1)}
                  variant="outlined"
                >
                  بازگشت به استان
                </Button>
              </div>{" "}
              <Cities
                cities={cities}
                setSelected={(e) => {
                  setData({ ...data, city: e });
                  setCurrentStep(3);
                }}
                selected={data?.cities}
                loading={loadingCities}
              />
            </>
          ) : (
            <>
              <div className="flex loginButton w-full my-7 items-center justify-between">
                <Button
                  sx={{
                    width: "165px !important",
                    color: "#fff !important",
                    borderColor: "#fff !important",
                  }}
                  onClick={() => setCurrentStep(2)}
                  variant="outlined"
                >
                  بازگشت و انتخاب شهر
                </Button>
                <Button
                  onClick={handleSumbit}
                  sx={{ width: "165px !important" }}
                  disabled={loadingSubmit}
                  variant="contained"
                >
                  {loadingSubmit ? (
                    <>
                      {" "}
                      <CircularProgress size={20} />
                    </>
                  ) : (
                    <> ثبت نام</>
                  )}
                </Button>
              </div>{" "}
              <Info
                err={error}
                data={data}
                setData={setData}
                setError={setError}
              />
            </>
          )}
        </Container>
      </Box>
    </div>
  );
};

export default Register;
